import axios from "axios";
import { useState, useEffect } from "react";                  

/* ------------------------------------------------------------------ */
export default function ApplicationMaintenance({ onBack, onSelect, selected_plant_id }) {
    const [product, setProduct] = useState("");
    const [quantity, setQuantity] = useState("");
    const [quantityUnit, setQuantityUnit] = useState("");
    const [dose, setDose] = useState("");
    const [doseUnit, setDoseUnit] = useState("");
    const [appType, setAppType] = useState("");
    const [appMode, setAppMode] = useState("");
    const [plantCount, setPlantCount] = useState(0);

    // Check if we have multiple plants (from a plot)
    useEffect(() => {
        if (Array.isArray(selected_plant_id)) {
            setPlantCount(selected_plant_id.length);
            console.log(`Found ${selected_plant_id.length} plants for application maintenance`);
        }
    }, [selected_plant_id]);

    const updateQuantity = (value, unit) => {
        if (unit) setQuantityUnit(unit);
        if (value !== undefined) setQuantity(value);
    };

    const updateDose = (value, unit) => {
        if (unit) setDoseUnit(unit);
        if (value !== undefined) setDose(value);
    };

    const org_id = localStorage.getItem("organization");

    const handleUpload = async () => {
        console.log('Selected plant ID:', selected_plant_id);
        try {
            // Validate inputs
            if (!product) {
                alert("Please enter a product name");
                return;
            }
            if (!quantity || !quantityUnit) {
                alert("Please enter a quantity and select a unit");
                return;
            }
            if (!dose || !doseUnit) {
                alert("Please enter a dose and select a unit");
                return;
            }
            if (!appType) {
                alert("Please select an application type");
                return;
            }
            if (!appMode) {
                alert("Please select an application mode");
                return;
            }
            
            // Create array of plant IDs
            const plantIds = Array.isArray(selected_plant_id) ? selected_plant_id : [selected_plant_id];
            
            // Send a single request with the array of plant IDs
            const requestData = {
                application_mode: appMode,
                application_type: appType,
                dose: dose,
                dose_unit: doseUnit,
                plant_id: plantIds,
                product: product,
                quantity: quantity,
                quantity_unit: quantityUnit
            };
            
            await axios.post(
                `/orgs/${org_id}/maintenance/application`,
                requestData,
                {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            
            alert('Upload complete');
            onBack && onBack(); // Return to previous screen after successful upload
        } catch (err) {
            console.error('Upload failed:', err);
            if (err.response?.status === 400) {
                alert('Upload failed - Check if all required fields are filled in correctly');
            } else if (err.response?.status === 401 || err.response?.status === 403) {
                alert("Upload failed - You are no longer logged in or you don't have access to this resource");
            } else if (err.response?.status === 500) {
                alert("Upload failed - Something went wrong in the service, please try again later");
            } else {
                alert(`Upload failed with error: ${err.response}`);
            }
        }
    };

    return (
        <>
            <div className="maintenanceHeader">
                <h3>Application & IPM</h3>
                <button className="uploadMaintenanceBtn" onClick={handleUpload}>Upload</button>
            </div>

            <div className="maintenaceGrid maintenanceList">
                <div className="dropdownBlock">
        <div className="purpleBtn extraGridBtn blueBtn" onClick={onBack}>
          Back
        </div>
        </div>
                
                {plantCount > 1 && (
                  <div className="plotMaintenanceNotice">
                    Applying application maintenance to all plants in plot ({plantCount} plants)
                  </div>
                )}
            </div>

            <div className="maintenaceGrid maintenanceList flexMaintenanceGrid" style={{ marginBottom: "20px" }}>
            <table className="maintenanceTable">
                <tbody>
                    <tr>
                        <td>Product</td>
                        <td><input
                        className="newMaintenanceInput"
                        type="text"
                        value={product}
                        onChange={(e) => setProduct(e.target.value)}
                        /></td>
                    </tr>
                    <tr>
                        <td>Quantity</td>
                        <td>
                            <input
                                className="newMaintenanceInput"
                                type="text"
                                value={quantity}
                                onKeyDown={(e) => {
                                    const isNumber = /[0-9]/.test(e.key);
                                    const isDot = e.key === ".";
                                    const hasDot = e.target.value.includes(".");
                                    if ((!isNumber && !isDot) || (isDot && hasDot)) {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === "" || /^\d*\.?\d*$/.test(value)) {
                                        if (value.includes(".") && value.split(".")[1]?.length > 2) {
                                            return;
                                        }
                                        updateQuantity(value);
                                    }
                                }}
                            />
                            <div>
                                <label><input type="radio" name="quantity-unit" value="#" className="tableRadio tableRadioScouting tableRadioApplication" onChange={(e) => updateQuantity(undefined, e.target.value)}/> #</label>
                                <label><input type="radio" name="quantity-unit" value="mg" className="tableRadio tableRadioScouting tableRadioApplication" onChange={(e) => updateQuantity(undefined, e.target.value)}/> mg</label>
                                <label><input type="radio" name="quantity-unit" value="ml" className="tableRadio tableRadioScouting tableRadioApplication" onChange={(e) => updateQuantity(undefined, e.target.value)}/> ml</label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Dose</td>
                        <td>
                            <input
                                className="newMaintenanceInput"
                                type="text"
                                value={dose}
                                onKeyDown={(e) => {
                                    const isNumber = /[0-9]/.test(e.key);
                                    const isDot = e.key === ".";
                                    const hasDot = e.target.value.includes(".");
                                    if ((!isNumber && !isDot) || (isDot && hasDot)) {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === "" || /^\d*\.?\d*$/.test(value)) {
                                        if (value.includes(".") && value.split(".")[1]?.length > 2) {
                                            return;
                                        }
                                        updateDose(value);
                                    }
                                }}
                            />
                            <div>
                                <label><input type="radio" name="dose-unit" value="#/m2" className="tableRadio tableRadioScouting tableRadioApplication" onChange={(e) => updateDose(undefined, e.target.value)}/> #/m²</label>
                                <label><input type="radio" name="dose-unit" value="mg/l" className="tableRadio tableRadioScouting tableRadioApplication" onChange={(e) => updateDose(undefined, e.target.value)}/> mg/l</label>
                                <label><input type="radio" name="dose-unit" value="ml/l" className="tableRadio tableRadioScouting tableRadioApplication" onChange={(e) => updateDose(undefined, e.target.value)}/> ml/l</label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Application Type</td>
                        <td>
                            <div>
                                <label><input type="radio" name="app-type" value="Spray" className="tableRadio tableRadioScouting" onChange={(e) => setAppType(e.target.value)}/> Spray</label>
                                <label><input type="radio" name="app-type" value="Drench" className="tableRadio tableRadioScouting" onChange={(e) => setAppType(e.target.value)}/> Drench</label>
                                <label><input type="radio" name="app-type" value="IPM" className="tableRadio tableRadioScouting" onChange={(e) => setAppType(e.target.value)}/> IPM</label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Application Mode</td>
                        <td>
                            <div>
                                <label><input type="radio" name="app-mode" value="Automated" className="tableRadio tableRadioScouting" onChange={(e) => setAppMode(e.target.value)}/> Automated</label>
                                <label><input type="radio" name="app-mode" value="Manual" className="tableRadio tableRadioScouting" onChange={(e) => setAppMode(e.target.value)}/> Manual</label>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
        </>
    )
}